import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Chip from "@material-ui/core/Chip";
import DeleteIcon from "@material-ui/icons/Delete";
import TableChartIcon from "@material-ui/icons/TableChart";
import DoneIcon from "@material-ui/icons/Done";
import GetAppIcon from "@material-ui/icons/GetApp";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment-timezone";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import Input from "@material-ui/core/Input";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import { axios } from "../../utils/axiosConfig";

const useStyles = makeStyles({
  root: {
    background: "#000"
    // padding: "8px"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  titleDiv: {
    display: "flex"
  },
  status: {
    fontSize: 14,
    color: "#fff",
    marginTop: "2px",
    fontStyle: "italic"
  },
  statusTime: {
    marginTop: 15
  },
  pos: {
    marginBottom: 12
  },
  linearProgress: {
    marginTop: "15px"
  },
  chip: {
    color: "primary",
    height: "23px"
  },
  jobCardTitle: {
    margin: "none",
    color: "#fff"
  },
  jobCardPrice: {
    color: "#fff",
    fontSize: "25px",
    // marginTop: "7px",
    marginBottom: "7px"
  },
  icon: {
    color: "#fff",
    margin: "4px 4px"
  },
  oilgasIcon: {
    margin: "auto",
    marginRight: "5px",
    color: "#e8e8e8",
    width: "65px",
    height: "40px"
  },
  editIcon: {
    color: "#fff",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "20px"
  },
  circularProgress: {
    width: "20px !important",
    height: "20px !important"
  },
  closeIcon: {
    color: "#fff",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "20px",
    marginTop: "20px"
  },
  center: {
    // margin: "auto",
    width: "fit-content",
    display: "flex"
  },
  inputFeild: {
    color: "#fff",
    fontSize: "32px",
    background: "none",
    textAlign: "center",
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none"
    }
  },
  jobCardButton: {
    color: "#fff",
    // borderRadius: '60%',
    fontSize: "12px",
    "&:hover": {
      backgroundColor: "#f15a2f"
    }
  },

  jobCardButton2: {
    // color:"#f15a2f",
    // borderRadius: '60%',
    fontSize: "12px",
    fontWeight: 600
    // "&:hover": {
    //   backgroundColor: '#ffff'
    // },
    // backgroundColor:"#ffff"
  },
  cardInfo: {
    marginTop: "15px"
  },
  tablePagination: {
    // position: 'sticky'
  },
  borderLeft: {
    borderLeft: "1px solid gray"
  },
  borderRight: {
    paddingTop: "25px",
    paddingBottom: "15px",
    paddingLeft: "15px",
    borderRight: "1px solid gray",
    borderTop: "1px solid gray"
  }
});

function OilIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
        <g id="001---Oil-Barrel" fill="rgb(255,255,255)">
          <path
            id="Shape"
            d="m0 56.5c0 1.9329966 1.56700338 3.5 3.5 3.5h35c1.8354698-.0003687 3.3588662-1.4185956 3.4903106-3.2493528.1314444-1.8307571-1.1737199-3.4520686-2.9903106-3.7146472v-5.072c1.7216859-.2488609 2.9992965-1.7244213 2.9992965-3.464s-1.2776106-3.2151391-2.9992965-3.464v-17.072c1.7216859-.2488609 2.9992965-1.7244213 2.9992965-3.464s-1.2776106-3.2151391-2.9992965-3.464v-5.072c1.8165907-.2625786 3.121755-1.8838901 2.9903106-3.71464723-.1314444-1.83075716-1.6548408-3.24898409-3.4903106-3.24935277h-21.5v-2c0-1.65685425-1.3431458-3-3-3h-6c-1.65685425 0-3 1.34314575-3 3v2h-1.5c-1.83546977.00036868-3.35886622 1.41859561-3.49031059 3.24935277-.13144437 1.83075713 1.17371986 3.45206863 2.99031059 3.71464723v5.072c-1.7216859.2488609-2.99929649 1.7244213-2.99929649 3.464s1.27761059 3.2151391 2.99929649 3.464v17.072c-1.7216859.2488609-2.99929649 1.7244213-2.99929649 3.464s1.27761059 3.2151391 2.99929649 3.464v5.072c-1.72196531.2485443-2.99994949 1.72419-3 3.464zm7-53.5c0-.55228475.44771525-1 1-1h6c.5522847 0 1 .44771525 1 1v2h-8zm-3.5 52h.5c.55228475 0 1-.4477153 1-1v-6h3c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-4.5c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5h9.5c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-8v-17h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9.5c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5h25.5c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-24v-5h23c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-24.5c-.82842712 0-1.5-.67157288-1.5-1.5s.67157288-1.5 1.5-1.5h35c.8284271 0 1.5.67157288 1.5 1.5s-.6715729 1.5-1.5 1.5h-.5c-.5522847 0-1 .4477153-1 1v6h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h4.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-9.5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8v17h-8c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-25.5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h24v5h-23c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h24.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-35c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5z"
          />
          <path
            id="Shape"
            d="m20.182 41.954c.2656246.0298381.5327048.0448614.8.045 1.8594589.0047815 3.6444122-.7304677 4.9610336-2.0435246s2.0567069-3.0960103 2.0569664-4.9554754c0-5.022-3.843-9.423-5.493-11.312-.3792756-.4363766-.9288357-.6872706-1.507-.688-.5749518-.0005887-1.1220011.2477717-1.5.681l-.076.087c-1.617 1.85-4.981 5.7-5.383 10.335-.3880803 3.8399307 2.3206264 7.3028939 6.141 7.851zm.747-16.87.08-.071c1.491 1.71 4.991 5.716 4.991 9.987-.0001549 1.4251147-.6084245 2.7824436-1.672 3.731-1.0656353.9601418-2.4954214 1.4107123-3.919 1.235-2.748379-.416716-4.6791537-2.9266791-4.377-5.69.346-3.986 3.42-7.502 4.897-9.192z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
function GasIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
        <g id="034---Gas-Canister" fill="rgb(255,255,255)">
          <path
            id="Shape"
            d="m7.457 23.853c.24226616.1081499.51757993.1155935.76533594.0206922.24775601-.0949012.44764466-.2843678.55566406-.5266922 1.19166156-2.6653285 3.5967073-4.5914506 6.458-5.172.5415152-.1088001.8923001-.6359848.7835-1.1775s-.6359848-.8923001-1.1775-.7835c-3.4957549.7087308-6.43421252 3.0617315-7.89 6.318-.10821287.2421421-.11580079.5173546-.02109444.7650914s.28394877.4477037.52609444.5559086z"
          />
          <path
            id="Shape"
            d="m31.867 25.143c-.6822683-5.6364659-4.5085162-10.3953303-9.867-12.272v-1.871c-.0052514-1.26678543-.8056491-2.39374545-2-2.816v-2.184c1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3h-6c-1.6568542 0-3 1.34314575-3 3s1.3431458 3 3 3v2.184c-1.1943509.42225455-1.9947486 1.54921457-2 2.816v1.88c-5.33580908 1.9019535-9.14892 6.642536-9.863 12.262-1.26448495.3774001-2.13259737 1.538404-2.137 2.858v1c.00525139 1.2667854.80564914 2.3937454 2 2.816v16.368c-1.19435086.4222546-1.99474861 1.5492146-2 2.816v1c.00525139 1.2667854.80564914 2.3937454 2 2.816v2.184c0 1.6568542 1.34314575 3 3 3h24c1.6568542 0 3-1.3431458 3-3v-2.184c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-16.368c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c-.0043109-1.3181252-.8704519-2.4782587-2.133-2.857zm-18.867-22.143c0-.55228475.4477153-1 1-1h6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-6c-.5522847 0-1-.44771525-1-1zm5 3v2h-2v-2zm-4 5c0-.5522847.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1v1.3c-.9874935-.199793-1.9924978-.3002935-3-.3-1.0079237.0013583-2.0130959.1052261-3 .31zm3 3c6.4074879-.0032661 11.8594964 4.6678215 12.839 11h-25.674c.99806865-6.3201996 6.4365074-10.9811132 12.835-11zm12 44h-24c-.55228475 0-1-.4477153-1-1v-2h26v2c0 .5522847-.4477153 1-1 1zm3-29c0 .5522847-.4477153 1-1 1h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8v16h-5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h6c.5522847 0 1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1h-28c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1h6c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-5v-16h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1h28c.5522847 0 1 .4477153 1 1z"
          />
          <path
            id="Shape"
            d="m20.24 36.036-.291-.274c-.4122049-.364585-.6715057-.8714003-.726-1.419-.01-.1-.016-.193-.019-.289l-.052-2.079c-.0103555-.402297-.260854-.7591897-.6356786-.9056704-.3748247-.1464806-.8009352-.0540054-1.0813214.2346704l-1.416 1.462c-.142.146-.287.289-.454.453-.4025954.3814587-.7803674.7882901-1.131 1.218-.9743603 1.0504831-1.3507182 2.5227954-1 3.912.1218908.375707.2919749.7340265.506 1.066.1397361.202896.2463954.4266779.316.663.027.131-.013.172-.031.191-.056.056-.149.089-.343.082-.1780538-.0514778-.3361165-.1561551-.453-.3l-1.045-1.187c-.2433479-.276433-.6189419-.3967365-.9776109-.3131306-.3586689.0836058-.642355.3575876-.7383891.7131306l-.42 1.551c-.58582979 1.9586496-.1944009 4.0795094 1.052 5.7.9660099 1.0845451 2.240153 1.8482634 3.652 2.189.7546563.1942028 1.5307563.2926431 2.31.293 2.1631497.1020677 4.2457635-.8313769 5.609-2.514 1.015367-1.4191145 1.3669121-3.2082021.964-4.906-.2726154-1.0980964-.7363547-2.1396482-1.37-3.077-.6415708-.906469-1.3884615-1.7335874-2.225-2.464zm1.025 9.264c-.990403 1.1660744-2.4731183 1.7962284-4 1.7-.607201.0000028-1.2119764-.0766021-1.8-.228-1.012632-.2368669-1.929641-.7752174-2.63-1.544-.7811446-1.0450317-1.0419093-2.3897376-.708-3.651.3613408.351678.8101938.6002735 1.3.72.8037536.1855412 1.6465664-.0528911 2.234-.632.5069926-.525498.71722-1.2699281.56-1.983-.1092944-.460708-.2992203-.8984515-.561-1.293-.122549-.1879078-.2232032-.3892161-.3-.6-.1486424-.768928.0950269-1.5614154.65-2.114.2993386-.3623341.6209616-.7056659.963-1.028l.251-.248c0 .054.009.107.014.16.1058596 1.0207736.583099 1.9670672 1.341 2.659l.3.282c.7209177.6240202 1.3657065 1.3309047 1.921 2.106.5043804.7414875.8740417 1.5661164 1.092 2.436.2712671 1.1255883.0426559 2.3134917-.627 3.258z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
function CustomerAccountRefIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg x="0px" y="0px" viewBox="0 0 314.3 314.3">
        <g>
          <g>
            <path
              d="M89.764,233.426H86.55l-27.195,25.873L32.16,233.426h-3.214C12.984,233.426,0,246.411,0,262.371v51.711h118.708v-51.711
			C118.708,246.411,105.724,233.426,89.764,233.426z M103.708,299.082H15v-36.711c0-6.822,4.925-12.517,11.407-13.713l32.947,31.347
			l32.947-31.347c6.482,1.196,11.407,6.891,11.407,13.713C103.708,262.371,103.708,299.082,103.708,299.082z"
            />
            <path
              d="M59.354,232.011c20.604,0,37.366-16.762,37.366-37.365s-16.762-37.365-37.366-37.365
			c-20.603,0-37.365,16.762-37.365,37.365S38.751,232.011,59.354,232.011z M59.354,172.281c12.333,0,22.366,10.033,22.366,22.365
			s-10.033,22.365-22.366,22.365c-12.332,0-22.365-10.033-22.365-22.365S47.022,172.281,59.354,172.281z"
            />
            <path
              d="M285.355,76.364h-3.215l-27.195,25.874L227.75,76.364h-3.214c-15.96,0-28.944,12.984-28.944,28.944v51.711H314.3v-51.711
			C314.3,89.348,301.315,76.364,285.355,76.364z M299.3,142.019h-88.708v-36.711c0-6.822,4.925-12.516,11.406-13.713l32.947,31.348
			l32.948-31.348c6.482,1.196,11.407,6.891,11.407,13.713V142.019z"
            />
            <path
              d="M254.946,74.95c20.603,0,37.365-16.762,37.365-37.365S275.549,0.218,254.946,0.218c-20.604,0-37.366,16.763-37.366,37.366
			S234.342,74.95,254.946,74.95z M254.946,15.218c12.332,0,22.365,10.033,22.365,22.366c0,12.332-10.033,22.365-22.365,22.365
			c-12.333,0-22.366-10.033-22.366-22.365C232.58,25.251,242.613,15.218,254.946,15.218z"
            />
            <polygon
              points="206.123,225.457 216.729,236.064 241.971,210.822 241.971,271.728 162.625,271.728 162.625,286.728 
			256.971,286.728 256.971,210.822 282.212,236.064 292.819,225.457 249.471,182.109 		"
            />
            <polygon
              points="51.44,92.019 26.199,66.777 15.592,77.384 58.94,120.732 102.289,77.384 91.682,66.777 66.44,92.019 
			66.44,31.112 145.787,31.112 145.787,16.112 51.44,16.112 		"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

function OrderNumberIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 512 512">
        <path d="m102.56 243.77h-2.32a6 6 0 1 0 0 12h2.32a6 6 0 1 0 0-12z" />
        <path d="m143.32 243.77h-17.56a6 6 0 0 0 0 12h17.56a6 6 0 0 0 0-12z" />
        <path d="m292.76 243.77h-125.87a6 6 0 0 0 0 12h125.87a6 6 0 0 0 0-12z" />
        <path d="m102.56 203.77h-2.32a6 6 0 1 0 0 12h2.32a6 6 0 1 0 0-12z" />
        <path d="m143.32 203.77h-17.56a6 6 0 0 0 0 12h17.56a6 6 0 0 0 0-12z" />
        <path d="m160.89 209.77a6 6 0 0 0 6 6h125.87a6 6 0 0 0 0-12h-125.87a6 6 0 0 0 -6 6z" />
        <path d="m102.56 283.77h-2.32a6 6 0 0 0 0 12h2.32a6 6 0 0 0 0-12z" />
        <path d="m143.32 283.77h-17.56a6 6 0 1 0 0 12h17.56a6 6 0 0 0 0-12z" />
        <path d="m102.56 323.77h-2.32a6 6 0 0 0 0 12h2.32a6 6 0 0 0 0-12z" />
        <path d="m143.32 323.77h-17.56a6 6 0 1 0 0 12h17.56a6 6 0 0 0 0-12z" />
        <path d="m121.01 166.958a20.762 20.762 0 0 0 -6-40.638 8.765 8.765 0 1 1 8.76-8.77 6 6 0 1 0 12 0 20.79 20.79 0 0 0 -14.76-19.868v-3.012a6 6 0 0 0 -12 0v3.011a20.761 20.761 0 0 0 6 40.639 8.764 8.764 0 0 1 .053 17.527h-.053-.053a8.773 8.773 0 0 1 -8.717-8.757 6 6 0 0 0 -12 0 20.793 20.793 0 0 0 14.77 19.869v3.681a6 6 0 0 0 12 0z" />
        <path d="m162.5 170.64a6 6 0 0 0 12 0v-3.681a20.761 20.761 0 0 0 -6-40.639 8.765 8.765 0 1 1 8.77-8.77 6 6 0 0 0 12 0 20.793 20.793 0 0 0 -14.77-19.869v-3.011a6 6 0 0 0 -12 0v3.011a20.761 20.761 0 0 0 6 40.639 8.764 8.764 0 0 1 .053 17.527h-.053-.053a8.773 8.773 0 0 1 -8.717-8.757 6 6 0 0 0 -12 0 20.793 20.793 0 0 0 14.77 19.869z" />
        <path d="m294.46 83.8a6 6 0 0 0 6-6v-6.83a6 6 0 1 0 -12 0v6.83a6 6 0 0 0 6 6z" />
        <path d="m294.46 160.24a6 6 0 0 0 6-6v-58.53a6 6 0 1 0 -12 0v58.53a6 6 0 0 0 6 6z" />
        <path d="m332.5 253.569v-240.939a6 6 0 0 0 -9.748-4.686l-28.762 23-28.752-23a6 6 0 0 0 -7.5 0l-28.752 23-28.752-23a6 6 0 0 0 -7.5 0l-28.752 23-28.752-23a6 6 0 0 0 -7.5 0l-28.752 23-28.741-23a6 6 0 0 0 -9.737 4.686v426.47a6 6 0 0 0 9.748 4.686l28.762-23 28.752 23a6 6 0 0 0 7.5 0l28.752-23 28.752 23a6 6 0 0 0 6.892.425l13.3-8.184a126 126 0 1 0 119.542-182.458zm-7 239.8a113.956 113.956 0 0 1 -112.551-95.769 6 6 0 0 0 -11.848 1.9 125.179 125.179 0 0 0 6.926 25.469l-11.066 6.808-29.2-23.362a6 6 0 0 0 -7.5 0l-28.752 23-28.752-23a6 6 0 0 0 -7.5 0l-22.757 18.204v-401.503l22.741 18.2a6 6 0 0 0 7.5 0l28.752-23 28.752 23a6 6 0 0 0 7.5 0l28.752-23 28.752 23a6 6 0 0 0 7.5 0l28.752-23 28.752 23a6 6 0 0 0 7.5 0l22.762-18.2v228.36a125.222 125.222 0 0 0 -77.071 30.294h-76.554a6 6 0 0 0 0 12h64.339a125.663 125.663 0 0 0 -18.845 28h-45.494a6 6 0 0 0 0 12h40.343a125.835 125.835 0 0 0 -7.638 38.663 6 6 0 0 0 11.991.462 114 114 0 0 1 113.914-109.525c.271 0 .551 0 .823.007h.129a114 114 0 0 1 -.952 227.99z" />
        <path d="m330.677 301.337a6 6 0 0 0 -10.354 0l-43.462 74.183a56.372 56.372 0 0 0 88.491 68.344 56.4 56.4 0 0 0 8.783-68.344zm26.192 134.039a44.366 44.366 0 0 1 -69.652-53.793l38.283-65.344 38.283 65.344a44.394 44.394 0 0 1 -6.914 53.793z" />
        <path d="m354.163 397.377a6.005 6.005 0 0 0 -7.065 4.7 21.924 21.924 0 0 1 -6.021 11.21 22.446 22.446 0 0 1 -3.946 3.146 22.927 22.927 0 0 1 -4.467 2.122 6 6 0 1 0 3.952 11.331 35 35 0 0 0 6.847-3.26 34.519 34.519 0 0 0 6.1-4.854 33.885 33.885 0 0 0 9.3-17.329 6 6 0 0 0 -4.7-7.066z" />
      </svg>
    </SvgIcon>
  );
}

function CustomerNameIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="-93 -20 637 637.33331">
        <path d="m220.25 276.625c35.660156-.03125 64.535156-28.96875 64.5-64.625-.03125-35.65625-28.96875-64.535156-64.628906-64.5-35.652344.035156-64.53125 28.96875-64.496094 64.625.113281 35.625 29 64.453125 64.625 64.5zm0-104.125c21.882812 0 39.625 17.738281 39.625 39.625 0 21.882812-17.742188 39.625-39.625 39.625-21.886719 0-39.625-17.742188-39.625-39.625.003906-21.882812 17.746094-39.621094 39.625-39.625zm0 0" />
        <path d="m133.5 415.75h173.496094c6.902344-.015625 12.480468-5.601562 12.5-12.5 0-28.25-10.246094-54.25-28.996094-73.375-18.546875-18.796875-43.847656-29.375-70.25-29.375s-51.703125 10.578125-70.25 29.375c-18.75 19.125-29 45.125-29 73.375.019531 6.898438 5.601562 12.484375 12.5 12.5zm34.375-68.375c13.835938-13.996094 32.695312-21.875 52.375-21.875 19.675781 0 38.539062 7.878906 52.371094 21.875 11.472656 11.835938 18.835937 27.039062 21.003906 43.375h-146.75c2.140625-16.34375 9.507812-31.5625 21-43.375zm0 0" />
        <path d="m382.75 42.5h-112.5v-30c-.019531-6.894531-5.605469-12.4804688-12.5-12.5h-75c-6.894531.0195312-12.480469 5.605469-12.5 12.5v30h-112.5c-34.511719.015625-62.484375 27.988281-62.5 62.5v430c.015625 34.511719 27.988281 62.484375 62.5 62.5h325c34.511719-.015625 62.484375-27.988281 62.5-62.5v-430c-.015625-34.511719-27.988281-62.484375-62.5-62.5zm-187.5-17.5h50v50h-50zm225 510c-.058594 20.683594-16.816406 37.441406-37.5 37.5h-325c-20.683594-.058594-37.441406-16.816406-37.5-37.5v-430c.058594-20.683594 16.816406-37.441406 37.5-37.5h112.5v20c.019531 6.894531 5.605469 12.480469 12.5 12.5h75c6.894531-.019531 12.480469-5.605469 12.5-12.5v-20h112.5c20.683594.058594 37.441406 16.816406 37.5 37.5zm0 0" />
        <path d="m355.5 505h-270.5c-6.902344 0-12.5 5.59375-12.5 12.5s5.597656 12.5 12.5 12.5h270.625c6.90625-.035156 12.472656-5.660156 12.4375-12.5625-.035156-6.90625-5.660156-12.472656-12.5625-12.4375zm0 0" />
        <path d="m147.5 450c-6.902344 0-12.5 5.59375-12.5 12.5s5.597656 12.5 12.5 12.5h145.625c6.90625 0 12.5-5.59375 12.5-12.5s-5.59375-12.5-12.5-12.5zm0 0" />
      </svg>
    </SvgIcon>
  );
}
function DriverNameIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg x="0px" y="0px" viewBox="0 0 512.204 512.204">
        <g id="XMLID_1062_">
          <g id="XMLID_727_">
            <path
              id="XMLID_728_"
              d="M328.945,285.952c-1.86,1.86-2.92,4.44-2.92,7.07c0,2.64,1.06,5.21,2.92,7.07    c1.87,1.869,4.44,2.93,7.07,2.93c2.64,0,5.21-1.061,7.08-2.93c1.86-1.86,2.92-4.44,2.92-7.07s-1.06-5.2-2.92-7.07    c-1.86-1.859-4.44-2.92-7.08-2.92C333.385,283.032,330.805,284.092,328.945,285.952z"
            />
            <path
              id="XMLID_1327_"
              d="M505.875,475.27l-0.631-0.631l-26.41-110.984c-11.297-47.474-53.27-80.63-102.069-80.63h-0.746    c-5.523,0-10,4.478-10,10s4.477,10,10,10h0.746c39.497,0,73.468,26.836,82.612,65.261l18.888,79.374l-85.167-85.167    c-1.875-1.875-4.419-2.929-7.071-2.929h-44.52c-1.266,0-2.494,0.249-3.637,0.696c-24.768-14.305-53-21.875-81.768-21.875    c-28.828,0-56.987,7.551-81.782,21.87c-1.139-0.443-2.362-0.691-3.623-0.691h-44.52c-2.652,0-5.196,1.054-7.071,2.929    l-85.228,85.228l18.769-79.329c9.106-38.487,43.088-65.367,82.638-65.367h76.719c12.165,10.718,27.614,16.587,43.972,16.587    c17.798,0,34.53-6.931,47.116-19.516c1.875-1.876,2.929-4.419,2.929-7.071v-51.309c21.825-13.673,37.694-36.002,42.762-62.142    h7.776c18.748,0,34-15.252,34-34v-5.393c0-18.748-15.252-34-34-34h-6.044V94.64c0-52.129-42.41-94.538-94.538-94.538    s-94.538,42.409-94.538,94.538v11.542h-6.044c-18.748,0-34,15.252-34,34v5.393c0,18.748,15.252,34,34,34h7.776    c5.068,26.14,20.937,48.469,42.762,62.142v41.309h-70.646c-23.524,0-46.64,8.037-65.09,22.631    c-18.45,14.595-31.594,35.239-37.01,58.131L6.956,474.644L6.33,475.27c-6.192,6.192-8.028,15.422-4.677,23.513    c3.352,8.092,11.176,13.319,19.933,13.319h67.707c3.534,0,6.806-1.865,8.606-4.907l33.561-56.713l3.071,1.975    c2.992,1.923,6.246,3.177,9.576,3.817c-5.809,14.143-9.021,29.616-9.021,45.828c0,5.522,4.477,10,10,10s10-4.478,10-10    c0-24.257,8.596-46.542,22.899-63.975l42.451,42.452c-3.808,6.286-6.003,13.653-6.003,21.523c0,5.522,4.477,10,10,10    s10-4.478,10-10c0-11.947,9.72-21.668,21.668-21.668s21.668,9.721,21.668,21.668c0,5.522,4.477,10,10,10s10-4.478,10-10    c0-7.87-2.195-15.237-6.003-21.523l42.451-42.451c14.303,17.433,22.899,39.718,22.899,63.975c0,5.522,4.477,10,10,10    s10-4.478,10-10c0-16.212-3.212-31.685-9.021-45.828c3.33-0.64,6.584-1.894,9.576-3.817l3.071-1.975l33.561,56.713    c1.8,3.042,5.072,4.907,8.606,4.907h67.707c8.757,0,16.582-5.228,19.933-13.319C513.903,490.692,512.067,481.463,505.875,475.27z     M370.557,140.182v5.393c0,7.72-6.28,14-14,14h-6.044v-33.393h6.044C364.277,126.182,370.557,132.463,370.557,140.182z     M181.437,94.64c0-41.101,33.438-74.538,74.538-74.538s74.538,33.438,74.538,74.538v11.542h-26.261    c-5.24,0-10.267-1.396-14.652-4.013c5.533-3.999,10.785-8.469,15.706-13.39c3.905-3.905,3.905-10.237,0-14.143    c-3.905-3.904-10.237-3.904-14.142,0c-20.341,20.342-47.387,31.545-76.155,31.545h-33.571V94.64z M141.393,145.575v-5.393    c0-7.72,6.28-14,14-14h6.044v33.393h-6.044C147.673,159.575,141.393,153.295,141.393,145.575z M181.438,161.567v-35.385h33.571    c19.801,0,38.914-4.476,56.183-12.95c9.022,8.366,20.688,12.95,33.061,12.95h26.261v35.365c0,41.101-33.438,74.538-74.538,74.538    C214.881,236.086,181.448,202.658,181.438,161.567z M255.975,256.086c10.498,0,20.601-1.723,30.044-4.896v37.457    c-17.297,14.594-42.792,14.594-60.089,0V251.19C235.374,254.363,245.477,256.086,255.975,256.086z M325.895,376.458l-8.111,13.877    c-1.15,1.968-2.022,4.041-2.639,6.165c-17.476-9.81-37.616-15.415-59.043-15.415c-21.427,0-41.567,5.605-59.043,15.415    c-0.617-2.124-1.489-4.196-2.639-6.164l-8.109-13.874c21.268-11.834,45.247-18.076,69.791-18.076    C280.597,358.386,304.644,364.633,325.895,376.458z M83.591,492.102H21.586c-0.288,0-1.053,0-1.456-0.973s0.138-1.514,0.342-1.717    l56.839-56.839l26.076,26.076L83.591,492.102z M133.547,428.048c-2.284-1.469-5.067-1.947-7.712-1.319    c-2.643,0.626-4.918,2.3-6.301,4.638l-5.63,9.514l-22.449-22.449l38.866-38.866h34.64l12.194,20.864    c1.58,2.702,1.28,6.121-0.745,8.508l-21.433,25.261c-2.387,2.813-6.527,3.428-9.63,1.436L133.547,428.048z M234.579,466.437    l-42.451-42.452c17.433-14.303,39.718-22.899,63.975-22.899s46.542,8.596,63.975,22.899l-42.452,42.452    c-6.286-3.808-13.653-6.002-21.523-6.002C248.232,460.434,240.865,462.629,234.579,466.437z M378.658,428.047l-11.8,7.586    c-3.103,1.996-7.243,1.378-9.629-1.435l-21.433-25.261c-2.025-2.387-2.325-5.806-0.745-8.509l12.194-20.863h34.64l38.866,38.866    l-22.449,22.449l-5.63-9.514c-1.383-2.338-3.658-4.012-6.301-4.638C383.726,426.102,380.943,426.579,378.658,428.047z     M492.074,491.13c-0.403,0.973-1.167,0.973-1.456,0.973h-62.005l-19.796-33.452l26.076-26.076l56.839,56.839    C491.936,489.616,492.477,490.157,492.074,491.13z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
function DepotIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        
        viewBox="0 0 512 512"
      
      >
        <path d="M143.32,198.45H376.98a6,6,0,0,0,0-12H143.32a6,6,0,0,0,0,12Z" />
        <path d="M382.98,232.45a6,6,0,0,0-6-6H143.32a6,6,0,0,0,0,12H376.98A6,6,0,0,0,382.98,232.45Z" />
        <path d="M186,171.255a47.528,47.528,0,0,0,41.007-71.547l-35.83-61.161a6,6,0,0,0-10.354,0l-35.83,61.161a6,6,0,0,0,10.354,6.065L186,53.45l30.653,52.323A35.525,35.525,0,1,1,150.47,123.71a6,6,0,0,0-12,0A47.543,47.543,0,0,0,186,171.255Z" />
        <path d="M193.54,146.4a5.978,5.978,0,0,0,1.961-.331,29.16,29.16,0,0,0,19.039-21.758,6,6,0,1,0-11.76-2.384,17.164,17.164,0,0,1-11.2,12.8A6,6,0,0,0,193.54,146.4Z" />
        <path d="M253.32,158.45H376.98a6,6,0,0,0,0-12H253.32a6,6,0,0,0,0,12Z" />
        <path d="M253.32,118.45H376.98a6,6,0,0,0,0-12H253.32a6,6,0,0,0,0,12Z" />
        <path d="M253.32,78.45H376.98a6,6,0,0,0,0-12H253.32a6,6,0,0,0,0,12Z" />
        <path d="M411.647,373.116,409.9,16.461a6,6,0,0,0-6-5.971H115.46a6,6,0,0,0-6,6V357.159L99.3,376.429a12.7,12.7,0,0,0,5.1,17.128l20.731,11.587a12.86,12.86,0,0,0,6.266,1.637,13.009,13.009,0,0,0,3.7-.541,12.751,12.751,0,0,0,7.709-6.3l2.1-3.962,7.05,5.831-12.987,17.859a20.231,20.231,0,0,0,16.377,32.117,20.591,20.591,0,0,0,3.271-.268,20.2,20.2,0,0,0,19.941,16.84,20.606,20.606,0,0,0,3.283-.269,20.178,20.178,0,0,0,19.931,16.851,20.528,20.528,0,0,0,3.286-.27,20.3,20.3,0,0,0,36.414,8.5l4-5.509,7.58,6a21.8,21.8,0,0,0,30.458-2.3,21.327,21.327,0,0,0,5.066-11.033,21.71,21.71,0,0,0,22.343-6.606,21.273,21.273,0,0,0,5.034-11.041,21.724,21.724,0,0,0,22.374-6.6,21.327,21.327,0,0,0,4.939-10.264,21.87,21.87,0,0,0,24-6.048l.26-.29.068-.076a21.01,21.01,0,0,0-2.2-29.8l-4.488-3.84a45.751,45.751,0,0,0,8.312-7.344,12.811,12.811,0,0,0,10.224,5.087,12.988,12.988,0,0,0,5.129-1.061l21.818-9.375a12.774,12.774,0,0,0,6.557-17.221ZM121.46,22.49H397.93l1.591,324.991-39.466-83.434a12.934,12.934,0,0,0-16.358-6.476l-22.427,8.76a12.78,12.78,0,0,0-6.929,17.4l2.231,4.69-.452.191c-8.488,1.744-14.431,1.487-23.251-.967l-22.411-6.24a35.865,35.865,0,0,0-20.393.325l-21.629,6.78a35.869,35.869,0,0,0-11.777,6.32,45.205,45.205,0,0,0-17.247-1.7l1.347-2.542a12.822,12.822,0,0,0-4.721-16.923l-20.593-12.416a12.9,12.9,0,0,0-18.073,5L121.46,334.391Zm40.635,413.9a8.314,8.314,0,0,1-11.533,1.868,8.236,8.236,0,0,1-1.879-11.535l21.54-29.62a8.277,8.277,0,0,1,14.987,4.821,8.172,8.172,0,0,1-1.575,4.835Zm23.333,16.421c-.036.049-.074.1-.111.157a8.335,8.335,0,0,1-11.547,1.865,8.211,8.211,0,0,1-1.867-11.512l15.61-21.478,0,0,0,0a8.271,8.271,0,0,1,14.97,4.84,8.167,8.167,0,0,1-1.574,4.833Zm23.21,16.59c-.035.048-.071.1-.107.15A8.331,8.331,0,0,1,197,471.416a8.237,8.237,0,0,1-1.935-11.444l.112-.161,10.69-14.7a8.282,8.282,0,0,1,15,4.821,8.113,8.113,0,0,1-1.577,4.826Zm29.852,7.186-6.722,9.528a8.341,8.341,0,0,1-11.563,1.875,8.228,8.228,0,0,1-1.936-11.424l.1-.14,5.868-8.058h0l0,0a8.268,8.268,0,0,1,14.252,8.222ZM358.571,431.5l-.284.317a9.833,9.833,0,0,1-13.769,1.041l-30.634-26.235a6,6,0,0,0-8.578.8,6.166,6.166,0,0,0,.964,8.483l22.082,18.922,0,0a9.422,9.422,0,0,1,.928,13.371,9.737,9.737,0,0,1-7.354,3.33,9.638,9.638,0,0,1-6.346-2.336l-22.032-18.869a6.167,6.167,0,0,0-8.529.355,6,6,0,0,0,.536,8.6l15.285,13.08c.057.054.116.106.175.157a9.518,9.518,0,0,1,.857,13.323,9.792,9.792,0,0,1-9.815,3.023,10.083,10.083,0,0,1-4.05-2.178l-15.156-12.979a6,6,0,0,0-8.931,1.275,6.134,6.134,0,0,0,1.273,7.965l8.274,7.1a9.457,9.457,0,0,1,1,13.439,9.8,9.8,0,0,1-13.7.981c-.058-.049-.116-.1-.175-.144l-9.674-7.661a20.165,20.165,0,0,0-18.293-23.6,20.243,20.243,0,0,0-8.229-19.582,20.1,20.1,0,0,0-10.141-3.677,20.262,20.262,0,0,0-8.233-19.6,20.143,20.143,0,0,0-9.349-3.611,20.274,20.274,0,0,0-36.15-16.543l-1.486,2.043-8.382-6.934,3.675-6.933a6.142,6.142,0,0,0-1.724-7.887,6,6,0,0,0-8.78,2.081l-11.613,21.911a.837.837,0,0,1-.517.412.921.921,0,0,1-.713-.072L110.25,383.079a.784.784,0,0,1-.332-1.051l58.066-110.174a.851.851,0,0,1,.54-.424.894.894,0,0,1,.718.1l20.592,12.415a.793.793,0,0,1,.314,1.047l-38.393,72.449a6.137,6.137,0,0,0,1.728,7.882,6,6,0,0,0,8.78-2.082l30.065-56.734a42.069,42.069,0,0,1,15.6-1.283,35.9,35.9,0,0,0-1.636,3.342l-6.61,15.958c-1.687,4.07-3.252,8.28-4.654,12.514l-6.6,19.96a6,6,0,0,0,3.295,7.382l1.4.611a34.668,34.668,0,0,0,33.259-2.542A33.6,33.6,0,0,0,241.452,337.6c.032-.329.059-.656.084-.988.272-1.272,1.772-7.482,5.593-9.587a4.266,4.266,0,0,1,3.2-.32l7.985,2.229a20.9,20.9,0,0,1,8.988,5.187l90.289,84.6a9.009,9.009,0,0,1,.981,12.771Zm43.553-49.917a.8.8,0,0,1-.463.464l-21.828,9.38a.89.89,0,0,1-1.153-.411l-27.929-58.692a6,6,0,0,0-10.836,5.157L363.243,386.5a33.777,33.777,0,0,1-11.9,11.086L275.7,325.558a32.914,32.914,0,0,0-14.159-8.177l-10.14-2.83a5.978,5.978,0,0,0-1.633-.221c-6.958.024-12.887,3.89-16.7,10.885a33.686,33.686,0,0,0-3.408,9.588l-.156,1.636a21.662,21.662,0,0,1-9.746,16,22.774,22.774,0,0,1-18.132,2.844l4.785-14.473c1.31-3.955,2.772-7.888,4.347-11.689l6.588-15.906a23.155,23.155,0,0,1,4.858-7.245,23.778,23.778,0,0,1,9.816-6l21.63-6.779a23.894,23.894,0,0,1,13.585-.216l22.411,6.24c10.853,3.021,18.854,3.3,29.518,1.029l2.563-.967,10.486,22.036a6,6,0,0,0,10.836-5.157l-17.88-37.577a.722.722,0,0,1-.021-.6.82.82,0,0,1,.48-.467l22.43-8.76a.9.9,0,0,1,1.143.427L402.1,380.991A.736.736,0,0,1,402.124,381.583Z" />
      </svg>
    </SvgIcon>
  );
}
function TruckIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 60 37">
        <g id="Page-1" fill="none" fill-rule="evenodd">
          <g id="012---Oil-Tanker" fill="rgb(255,255,255)" fill-rule="nonzero">
            <path
              id="Shape"
              d="m58 26.184v-8.584c.0065887-1.4082155-.9728589-2.6290851-2.349-2.928l-6.651-1.472v-7.478c.6167513-.35441258.997855-1.01067322 1-1.722v-2c0-1.1045695-.8954305-2-2-2h-12c-1.1045695 0-2 .8954305-2 2v2c.002145.71132678.3832487 1.36758742 1 1.722v15.278h-3.841c2.7999897-4.1714441 2.3435434-9.7247358-1.1-13.383-.3815032-.39651996-.9087577-.61949185-1.459-.617h-.6v-1c0-1.65685425-1.3431458-3-3-3h-2c-1.6568542 0-3 1.34314575-3 3v1h-6v-1c0-1.65685425-1.3431458-3-3-3h-2c-1.65685425 0-3 1.34314575-3 3v1.04c-.4033653.07945014-.77244705.28127536-1.057.578-3.44365475 3.6576122-3.90091669 9.2103157-1.102 13.382h-1.841c-1.1045695 0-2 .8954305-2 2v5.4c.00122971 1.4069518.98005379 2.6240368 2.354 2.927l4.816 1.065c.23204042.9699758.70299734 1.8665128 1.37 2.608h-2.54c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h53c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-6.54c.5232082-.5827495.927455-1.2621559 1.19-2h3.35c1.6568542 0 3-1.3431458 3-3v-1c-.0052514-1.2667854-.8056491-2.3937454-2-2.816zm-2-4.184h-3v-2h3zm-.783-5.372c.4572436.0993242.7833074.5040931.783.972v.4h-3c-1.1045695 0-2 .8954305-2 2v2c0 1.1045695.8954305 2 2 2h3l.0000002 2h-4.6900002c-2.0052528-1.3333467-4.6147472-1.3333467-6.62 0h-7.69v-20h10v2h-5c-1.1045695 0-2 .8954305-2 2v3c0 1.1045695.8954305 2 2 2h5.891zm-34.217 14.372h-2c-.000485-1.0542277-.2806853-2.0894502-.812-3h3.624c-.5313147.9105498-.811515 1.9457723-.812 3zm-2.35 2h2.7c.262545.7378441.6667918 1.4172505 1.19 2h-5.08c.5232082-.5827495.927455-1.2621559 1.19-2zm4.35-2c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4-4-1.790861-4-4zm9.65 2h9.7c.262545.7378441.6667918 1.4172505 1.19 2h-12.08c.5232082-.5827495.927455-1.2621559 1.19-2zm9.35-2h-9c-.000485-1.0542277-.2806853-2.0894502-.812-3h10.624c-.5313147.9105498-.811515 1.9457723-.812 3zm0-18v-3h5v3zm-6-11h12v2h-12zm-7.394 6.994c3.1741244 3.3726231 3.1741244 8.6333769 0 12.006h-2.606v-12h1c.01 0 .019-.006.029-.006zm-17.606.006h13v12h-13zm11-3c0-.55228475.4477153-1 1-1h2c.5522847 0 1 .44771525 1 1v1h-4zm-14 0c0-.55228475.44771525-1 1-1h2c.5522847 0 1 .44771525 1 1v1h-4zm-1.6 3h2.6v12h-2.611c-3.17374937-3.3721434-3.16892629-8.6336808.011-12zm-4.4 14h33v3h-4.69c-2.0052528-1.3333467-4.6147472-1.3333467-6.62 0h-7.38c-2.0052528-1.3333467-4.6147472-1.3333467-6.62 0h-7.69zm0 5.4v-.4h5.812c-.41357595.7103048-.67573614 1.4984877-.77 2.315l-4.25-.94c-.46065254-.0979558-.79052598-.50405-.792-.975zm7 2.6c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-1.060866 0-2.0782816-.4214274-2.8284271-1.1715729-.75014554-.7501455-1.1715729-1.7675611-1.1715729-2.8284271zm35 0c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4-4-1.790861-4-4zm14-1c0 .5522847-.4477153 1-1 1h-3c-.000485-1.0542277-.2806853-2.0894502-.812-3h3.812c.5522847 0 1 .4477153 1 1z"
            />
            <circle id="Oval" cx="27" cy="31" r="1" />
            <circle id="Oval" cx="13" cy="31" r="1" />
            <circle id="Oval" cx="48" cy="31" r="1" />
            <path
              id="Shape"
              d="m2 35h-1c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h1c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
function capitalizeFirstLetter([first, ...rest], locale = navigator.language) {
  return [first.toLocaleUpperCase(locale), ...rest].join("");
}

function JobSub(props) {
  console.log(props.jobData, "props");
  const classes = useStyles();

  const [job, setJob] = React.useState(false);

  useEffect(() => {
    setJob(props.jobData);
  }, [props.jobData]);

  return (
    <Card className={classes.root}>
      <Grid container>
        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <CustomerAccountRefIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Customer Name
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.customerName}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>

        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <OrderNumberIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Order Number
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.orderNumber}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <CustomerNameIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Invoice Name
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.invoiceNumber}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <DriverNameIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Operator Name
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.operatorName}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <TruckIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Customer Type
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.customerType}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>
     
        
        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.borderRight}>
          <div className={classes.center}>
            <DepotIcon className={classes.oilgasIcon} />
            <div>
              <Typography
                variant="p"
                component="p"
                className={classes.jobCardTitle}
              >
                Zone Reference
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.jobCardPrice}
              >
                {job && job.zoneReference}
              </Typography>
              {/* )} */}
            </div>
          </div>
          {/* {!keroValue && ( */}
        </Grid>
      </Grid>
    </Card>
  );
}

export default JobSub;
